var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataMp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 353,
    viewBox: "0 0 409 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-220.275 -170.298L-220.275 558.543M630.419 -170.012H-219.99M-179.752 -170.298L-179.752 558.543M630.419 -129.49H-219.99M-139.229 -170.298L-139.229 558.543M630.419 -88.9667H-219.99M-98.7066 -170.298L-98.7066 558.543M630.419 -48.4439H-219.99M-58.1838 -170.298L-58.1838 558.543M630.419 -7.92102H-219.99M-17.661 -170.298L-17.6609 558.543M630.419 32.6018H-219.99M22.8619 -170.298L22.8619 558.543M630.419 73.1246H-219.99M63.3847 -170.298L63.3847 558.543M630.419 113.647H-219.99M103.908 -170.298L103.908 558.543M630.419 154.17H-219.99M144.43 -170.298L144.43 558.543M630.419 194.693H-219.99M184.953 -170.298L184.953 558.543M630.419 235.216H-219.99M225.476 -170.298L225.476 558.543M630.419 275.739H-219.99M265.999 -170.298L265.999 558.543M630.419 316.262H-219.99M306.522 -170.298V558.543M630.419 356.784H-219.99M347.045 -170.298V558.543M630.419 397.307H-219.99M387.567 -170.298V558.543M630.419 437.83H-219.99M428.09 -170.298V558.543M630.419 478.353H-219.99M468.613 -170.298V558.543M630.419 518.876H-219.99M509.136 -170.298V558.543M630.419 559.399H-219.99M549.659 -170.298V558.543M590.182 -170.298V558.543M630.704 -170.298V558.543",
    stroke: "url(#paint0_radial_1_1767)",
    strokeOpacity: 0.8,
    strokeWidth: 0.570744
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.801 223.199C178.291 221.487 167.137 224.697 158.986 232.827C155.769 236.037 153.41 239.674 151.694 243.526C159.201 242.135 167.888 241.921 177.218 243.098C180.221 236.251 184.082 229.511 188.801 223.199Z",
    stroke: "#3B1676",
    strokeWidth: 1.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.65 291.347C214.54 294.557 210.786 296.911 206.925 298.622C208.752 290.717 207.998 278.082 207.354 273.053C214.218 270.165 220.867 266.313 227.302 261.606C229.018 272.197 225.801 283.217 217.65 291.347Z",
    stroke: "#3B1676",
    strokeWidth: 1.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.096 257.006C204.244 261.713 209.713 265.564 215.612 268.881",
    stroke: "#3B1676",
    strokeWidth: 1.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.508 234.753C184.725 240.53 188.693 246.094 193.412 251.229",
    stroke: "#3B1676",
    strokeWidth: 1.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.685 270.699C178.076 269.095 178.076 266.527 179.685 264.922L201.134 243.526C202.743 241.921 205.316 241.921 206.925 243.526C208.534 245.13 208.534 247.698 206.925 249.303L185.476 270.699C183.867 272.304 181.293 272.304 179.685 270.699Z",
    stroke: "#3B1676",
    strokeWidth: 1.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.305 262.783C197.702 266.741 202.314 270.165 207.14 273.16C218.829 268.132 230.198 260.536 240.279 250.48M187.514 257.006C183.546 252.726 180.114 248.019 177.111 243.205C182.259 231.544 189.766 220.204 199.847 210.147C209.609 200.459 220.575 193.032 231.892 187.977M249.428 240.156C264.018 221.475 271.225 199.761 270.415 180.085C260.625 179.683 250.35 181.253 240.189 184.714",
    stroke: "#3B1676",
    strokeWidth: 1.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.89 183.295C247.678 187.895 250.896 192.067 254.757 195.812C258.618 199.663 262.8 202.872 267.304 205.547",
    stroke: "#3B1676",
    strokeWidth: 1.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.893 274.47C155.604 270.471 152.376 261.569 144.737 265.448C139.254 268.232 140.473 274.182 143.486 277.062",
    stroke: "#167648",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.392 279.846C151.276 277.158 142.467 278.847 144.448 286.469C145.518 290.584 153.585 292.772 157.335 290.692",
    stroke: "#167648",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.009 288.484C159.323 287.94 161.894 287.678 161.663 290.98C161.432 294.281 158.425 296.259 156.951 296.835C155.845 297.266 154.181 296.681 154.258 294.147",
    stroke: "#167648",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.452 307.201C165.799 308.545 169.396 310.637 173.012 308.257",
    stroke: "#167648",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170.992 296.45C169.999 294.563 167.011 291.786 163.01 295.778C158.009 300.77 165.03 305.281 167.242 304.801",
    stroke: "#167648",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.205 293.283C181.219 293.987 187.614 296.985 186.188 302.785C184.938 307.872 178.59 306.977 175.32 305.377",
    stroke: "#167648",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M169.934 274.854C169.704 275.238 162.978 279.43 159.644 281.477",
    stroke: "#167648",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M172.531 278.982L164.356 287.14",
    stroke: "#167648",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M176.282 281.765L170.031 291.075",
    stroke: "#167648",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M229.265 209.38C235.631 209.381 240.789 214.531 240.789 220.881C240.789 227.232 235.631 232.382 229.265 232.382C222.899 232.382 217.739 227.232 217.739 220.881C217.739 214.531 222.899 209.38 229.265 209.38Z",
    stroke: "#F89100",
    strokeWidth: 1.16
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_1767",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.215 194.55) rotate(90) scale(364.848 425.49)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 409,
    height: 333,
    fill: "white",
    transform: "translate(0 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataMp);
export default __webpack_public_path__ + "static/media/no_data_mp.892787a5461bc3cc598fcd574af53fca.svg";
export { ForwardRef as ReactComponent };